module.exports = __webpack_public_path__ + "img/globe-mail.9961879b.png";